import { css } from '@emotion/react';

export const animationStyles = css`
  @keyframes slideInDown {
    from {
      transform: translate3d(0, -100%, 0);
      visibility: visible;
    }

    to {
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes slideInRight {
    from {
      transform: translate3d(100%, 0, 0);
      visibility: visible;
    }

    to {
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes slideInLeft {
    from {
      transform: translate3d(-100%, 0, 0);
      visibility: visible;
    }

    to {
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes fadeOutLeft {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      transform: translate3d(-100%, 0, 0);
    }
  }
  @keyframes fadeOutRight {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      transform: translate3d(100%, 0, 0);
    }
  }
  @keyframes fadeOutDown {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      transform: translate3d(0, 100%, 0);
    }
  }
  @keyframes slideDownAnim {
    100% {
      transform: translateY(50%);
      background-color: #f4f5f7;
    }
  }
  @keyframes slideUpAnim {
    100% {
      transform: translate3d(0, -100%, 0);
      visibility: hidden;
    }
  }
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translate3d(0, 100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes fadeOut {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
    }
  }
  @keyframes showUpLeft {
    from {
      opacity: 0;
      width: 0;
    }

    to {
      opacity: 1;
      width: 50%;
    }
  }
  @keyframes zoomOut {
    from {
      opacity: 1;
    }

    50% {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }

    to {
      opacity: 0;
    }
  }
  :root {
    --animate-duration: 1s;
    --animate-delay: 1s;
    --animate-repeat: 1;
  }
  .animated {
    animation-duration: var(--animate-duration);
    animation-fill-mode: both;
  }
  .animated.faster {
    animation-duration: calc(var(--animate-duration) / 2);
  }

  .animated.fast {
    animation-duration: calc(var(--animate-duration) * 0.8);
  }

  .animated.slow {
    animation-duration: calc(var(--animate-duration) * 2);
  }

  .animated.slower {
    animation-duration: calc(var(--animate-duration) * 3);
  }
  .slideInDown {
    animation-name: slideInDown;
  }
  .fadeOutLeft {
    animation-name: fadeOutLeft;
  }
  .slideInLeft {
    animation-name: slideInLeft;
  }
  .slideInRight {
    animation-name: slideInRight;
  }
  .fadeOutRight {
    animation-name: fadeOutRight;
  }
  .fadeOutDown {
    animation-name: fadeOutDown;
  }
  .fadeInUp {
    animation-name: fadeInUp;
  }
  .showUpLeft {
    animation-name: showUpLeft;
  }
  .fadeOut {
    animation-name: fadeOut;
  }
  .zoomOut {
    animation-name: zoomOut;
  }
  .animated.delay-01s {
    animation-delay: 0.1s;
  }
  .animated.delay-02s {
    animation-delay: 0.2s;
  }
  .animated.delay-03s {
    animation-delay: 0.3s;
  }
  .animated.delay-04s {
    animation-delay: 0.4s;
  }
  .animated.delay-05s {
    animation-delay: 0.5s;
  }
  .animated.delay-06s {
    animation-delay: 0.6s;
  }
  .animated.delay-07s {
    animation-delay: 0.7s;
  }
  .animated.delay-08s {
    animation-delay: 0.8s;
  }
  .animated.delay-09s {
    animation-delay: 0.9s;
  }
  .animated.delay-1-1s {
    animation-delay: 1.1s;
  }
  .animated.delay-1-2s {
    animation-delay: 1.2s;
  }
  .animated.delay-1-3s {
    animation-delay: 1.3s;
  }
  .slideUpAnimation {
    animation: slideUpAnim 0.5s ease-in forwards !important;
  }
  .slideDownTriangle {
    animation: slideDownAnim 0.5s ease-in forwards !important;
  }
  div[id^='__lpform_'] {
    display: none;
  }
  body {
    margin: 0;
  }
`;
